import { pageInfo, queuesTop } from '../api';
import { plant } from '../../../../api'
const vehicleQueues = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: [],
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = (data.obj || []).map(item => ({ key: item.plantName, value: item.plantCode }))
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
  }
}
export default vehicleQueues



// WEBPACK FOOTER //
// ./src/page/bd/vehicleQueues/store/vehicleQueues.store.js